/* eslint-disable react-hooks/exhaustive-deps */

import { Box, Button, MenuItem } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import React from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { CustomOnClickWrapper } from "../../../../components/CustomLink/CustomClickWrapper";
import { StandardTableActions } from "../../../../components/StandardTableActions/StandardTableActions";
import { DataTable } from "../../../../components/Table/DataTable";
import {
  IDataTableProps,
  MobileLogoRenderType,
  RenderType,
} from "../../../../components/Table/interfaces/IDataTableProps";
import {
  CSVExportPlugin,
  RefreshPlugin,
  SearchPlugin,
} from "../../../../components/Table/plugins";
import { PageContainer } from "../../../../components/container/PageContainer";
import { CustomSelect } from "../../../../components/formsComponents";
import { LoadState, MODULE_IDS } from "../../../../constants/enums";
import { useDispatchWrapper } from "../../../../hooks";

import { IJobContact } from "../../../../redux/job_contacts";
import {
  clearCustomerBranch,
  fetchCustomerBranchListAsync,
  IJobCustomerBranch,
  initialJobCustomerBranch,
} from "../../../../redux/customerBranch";
import { IStoreState } from "../../../../redux";
import { ManageCustomerBranch } from "./ManageCustomerBranch";
import { RoleBasedCustomButton } from "../../../../security/RoleBasedComponents/RoleBasedCustomButton/RoleBasedCustomButton";

interface ICustomerBranchProps {
  isBillingCompany: number;
}

export const CustomerBranches: React.FC<ICustomerBranchProps> = (props) => {
  const { isBillingCompany } = props;
  const { uuid } = useParams() as { uuid?: string };

  const { list, totalRecords, loading } = useSelector(
    (storeState: IStoreState) => storeState.job_customerBranch,
  );

  const { data: customerData } = useSelector(
    (storeState: IStoreState) => storeState.job_customer.customer,
  );

  const [status, setStatus] = React.useState<IJobContact["status"] | "-1">(
    "-1",
  );
  const [searchColumns, setSearchColumns] = React.useState<string[]>([
    "customer_name",
  ]);
  const [search, setSearch] = React.useState<string>("");
  const [pagination, setPagination] = React.useState<{
    pageNumber: number;
    rowsPerPage: number;
  }>({ pageNumber: 1, rowsPerPage: 10 });

  const dispatch = useDispatchWrapper();

  // ******Right Panel************
  const [openDialog, setOpenDialog] = React.useState<boolean>(false);
  const [dialogData, setDialogData] = React.useState<IJobCustomerBranch>(
    initialJobCustomerBranch,
  );

  const handleOpenDialog = () => {
    setOpenDialog(true);
    setDialogData({
      ...initialJobCustomerBranch,
      customer_name: customerData.customer_name,
      customer_uuid: customerData.customer_uuid,
    });
  };
  const handleCloseDialog = () => {
    setOpenDialog(false);
    dispatch(clearCustomerBranch());
  };
  const handleComplete = () => {
    setOpenDialog(false);
    dispatch(clearCustomerBranch());
    fetchList();
  };

  const contactsTableProps: IDataTableProps = {
    isPagination: true,
    totalRecords: totalRecords,
    rowsPerPageOptions: pagination.rowsPerPage,
    isDataLoading: loading !== LoadState.Loaded,
    selectionMode: "none",
    uniqueRowKeyName: "id",
    tableCommandBarProps: {
      leftItems: {
        customPlugins: [
          {
            key: "status",
            onRender: () => (
              <CustomSelect
                sx={{ minWidth: "120px" }}
                value={status}
                onChange={(e: any) => setStatus(e.target.value as "ACTIVE")}
              >
                <MenuItem value="-1">All Status</MenuItem>
                <MenuItem value="ACTIVE">Active</MenuItem>
                <MenuItem value="INACTIVE">Inactive</MenuItem>
              </CustomSelect>
            ),
          },
          {
            key: "csvExport",
            onRender: (columns, items) => (
              <CSVExportPlugin
                columns={columns}
                items={items}
                filePrefixName="Report"
              />
            ),
          },
          {
            key: "refresh",
            onRender: () => <RefreshPlugin onClick={fetchList} />,
          },
        ],
      },
      rightItems: {
        plugins: {},
        customPlugins: [
          {
            key: "search",
            onRender: () => {
              return (
                <SearchPlugin
                  selectedDropdownValue={searchColumns}
                  dropdownOptions={[
                    { label: "Customer Name", value: "customer_name" },
                    { label: "Branch Name", value: "customer_branch_name" },
                    { label: "City", value: "customer_branch_address_city" },
                    { label: "Mobile", value: "customer_branch_mobile" },
                  ]}
                  onDropdownChange={(value) => setSearchColumns(value)}
                  onChange={(newValue) => {
                    setSearch(newValue);
                  }}
                />
              );
            },
          },
        ],
      },
    },
    mobileLogo: {
      type: MobileLogoRenderType.reactNode,
      onMobileLogoRender: (data: any) => {
        return (
          <Avatar
            sx={{
              width: 45,
              height: 45,
              color: "#fff",
              ml: "-8px",
              mr: 2,
            }}
          ></Avatar>
        );
      },
    },
    columns: [
      {
        key: "customer_branch_name",
        headerName: isBillingCompany === 1 ? "Branch Name" : "Billing State",
        fieldName: "customer_branch_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
        onRowCellRender: (value, row: IJobCustomerBranch) => {
          return (
            <CustomOnClickWrapper
              label={row.customer_branch_name || ""}
              onClick={() => {
                setOpenDialog(true);
                setDialogData(row);
              }}
            />
          );
        },
      },
      {
        key: "customer_name",
        headerName: isBillingCompany === 1 ? "Company Name" : "Customer Name",
        fieldName: "customer_name",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "customer_branch_address_city",
        headerName: "City",
        fieldName: "customer_branch_address_city",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "customer_branch_mobile",
        headerName: "Mobile",
        fieldName: "customer_branch_mobile",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },
      {
        key: "customer_branch_website",
        headerName: "Webiste",
        fieldName: "customer_branch_website",
        renderType: RenderType.TEXT,
        exportCellWidth: 30,
        enableSorting: true,
      },

      {
        key: "view",
        headerName: "Actions",
        fieldName: "",
        headingAlign: "center",
        renderType: RenderType.CUSTOM_RENDER,
        onRowCellRender: (value, row: IJobCustomerBranch) => {
          return (
            <StandardTableActions
              onEditClick={() => {
                setOpenDialog(true);
                setDialogData(row);
              }}
            />
          );
        },
      },
    ],
    items: list,
    onPageChange: (newPageNumber: number) => {
      setPagination({ ...pagination, pageNumber: newPageNumber });
    },
    onRowsPerPageChange: (pageNumber: number, rowsPerPage: number) => {
      setPagination({
        pageNumber: pageNumber,
        rowsPerPage: rowsPerPage,
      });
    },
  };

  const fetchList = () => {
    dispatch(
      fetchCustomerBranchListAsync(
        {
          status: status,
          page: pagination.pageNumber,
          rowsPerPage: pagination.rowsPerPage,
          columns: searchColumns,
          value: search,
        },
        uuid,
      ),
    );
  };

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pagination, status, search]);

  return (
    <PageContainer title="" description="">
      <Box
        display={"flex"}
        justifyContent={"end"}
        sx={{
          mx: 5,
          my: 2,
        }}
      >
        {/* <Button
					variant="contained"
					onClick={() => handleOpenDialog()}
				>
					Add New
				</Button> */}
        <RoleBasedCustomButton
          moduleId={MODULE_IDS.COMPANY_BRANCH}
          variant="contained"
          onClick={() => handleOpenDialog()}
        >
          Add New
        </RoleBasedCustomButton>
      </Box>
      <DataTable {...contactsTableProps} />
      {openDialog && (
        <ManageCustomerBranch
          open={openDialog}
          data={dialogData}
          isBillingCompany={
            customerData.is_billing_company === 1 ? true : false
          }
          onClose={() => handleCloseDialog()}
          onComplete={() => handleComplete()}
        />
      )}
    </PageContainer>
  );
};
